<template>
  <v-container fluid grid-list-xl v-if="showDashboard">
    <DashboardSales />
    <v-layout row wrap>
      <v-flex xs12 md8 m0a>
        <CMReceived />
      </v-flex>
      <v-flex xs12 md8 m0a>
        <Agenda />
      </v-flex>
      <v-flex xs12 md8 m0a>
        <SalesExport />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

// import fullCalendar from 'vue-fullcalendar' // https://github.com/Wanderxx/vue-fullcalendar
import DashboardSales from './DashboardSales.vue'
import Agenda from './Agenda'
import CMReceived from './CMReceived'
import SalesExport from './SalesExport'
export default {
  components: {
    // fullCalendar
    Agenda,
    CMReceived,
    DashboardSales,
    SalesExport
  },
  data () {
    return {
      loggedInUser: JSON.parse(atob(localStorage.getItem('user'))),
      showDetails: false,
      showDashboard: false
    }
  },
  computed: {
    filteredOrderDetails () {
      return this.orderDetails.filter(o => !(this.notToShowStatuses.indexOf(o._id) > -1))
    }
  },
  async mounted () {
    if (this.loggedInUser.email === 'books@diyblinds.com.au') {
      this.showDashboard = false
    } else if (this.loggedInUser.position && ['manager'].includes(this.loggedInUser.position.role)) {
      this.showDashboard = true
    } else if (this.loggedInUser.position && ['installations'].includes(this.loggedInUser.position.role)) {
      this.$router.replace('/dashboard/installation')
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.link {
  cursor: pointer;
}
.link:hover {
  opacity: 0.7
}
.event-box {
    padding: 25px;
}
.m0a {
  margin: 0 auto;
}
.pie-wrapper {
  width: 20%;
  float: left;
}
.pie {
  width: 250px;
  height: 250px;
  max-width: 100%;
  max-height: 100%;
  background-image: conic-gradient(#ea4d76 50%, #565e6f 50%);
  border-radius: 50%;
  position: relative;
  margin: 0 auto;
  cursor: pointer;
}
.pieClicked {
  border: 5px green solid;
  background: #fff;
  background-image: none !important;
}
.pieClicked .txt {
  color: green !important;
}
.pie-wrapper2 .pie {
  width: 350px;
  height: 350px;
}
.pie .txt {
  position: absolute;
  color: #fff;
  font-size: 32px;
  font-weight: bold;
  width: 100px;
  text-align: center;
  width: 100%;
  top: 40%;
}
.pie .txt2 {
  top: 45%;
  font-size: 26px;
}
.pie .txt3 {
  top: 10%;
}
.pie .txt2 > div {
  float: left;
}
.top-text {
  text-align: center;
  color: #ea4d76;
  margin: 20px;
}
.top-text2 {
  color: #565e6f;
  margin-bottom: 20px;
}
.tb {
  content: '';
  border-bottom: 4px solid #ea4d76;
  height: 175px;
  width: calc(100% - 60px);
  margin-left: 30px;
}
@media screen and (max-width: 661px) {
  .pie-wrapper {
    width: 100%;
    float: left;
  }
  .top-text2 {
    text-align: center;
  }
  .tb {
    height: 25px;
    border-right: 4px solid #ea4d76;
    margin: 0 auto;
    width: 4px;
    border-bottom: none;
  }
  .pie-wrapper2 .pie[data-v-aae30ed8] {
    max-width: 290px;
    max-height: 290px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue